var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoopLogo = function SvgLoopLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loopLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#113628",
    d: "M60.445 0H3.555A3.555 3.555 0 0 0 0 3.555v56.89A3.555 3.555 0 0 0 3.555 64h56.89A3.555 3.555 0 0 0 64 60.445V3.555A3.555 3.555 0 0 0 60.445 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#153626",
    d: "M32.146 54.633c-.161 0-.291.13-.291.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.834 16.504c.02-2.132.464-4.264.755-6.392a4 4 0 0 0 .025-.26.393.393 0 0 0-.394-.394h-7.086a.393.393 0 0 0-.394.393c0 .038.017.201.025.261.288 2.128.732 4.257.755 6.392.018 1.628.03 27.989 0 30.992-.02 2.132-.464 4.264-.755 6.392-.008.057-.025.22-.025.26 0 .219.175.394.394.394h7.086a.395.395 0 0 0 .394-.393c0-.038-.017-.201-.025-.261-.288-2.128-.732-4.257-.755-6.392-.03-3.033-.015-29.389 0-30.992M49.48 16.504c.02-2.132.464-4.264.755-6.392a4 4 0 0 0 .025-.26.393.393 0 0 0-.394-.394H42.78a.393.393 0 0 0-.394.393c0 .038.017.201.025.261.288 2.128.732 4.257.755 6.392.018 1.628.03 27.989 0 30.992-.02 2.132-.464 4.264-.755 6.392-.008.057-.025.22-.025.26 0 .219.175.394.394.394h7.086a.395.395 0 0 0 .394-.393c0-.038-.017-.201-.025-.261-.288-2.128-.732-4.257-.755-6.392-.03-3.033-.015-29.389 0-30.992M32 25.352A6.656 6.656 0 0 0 25.352 32 6.656 6.656 0 0 0 32 38.648 6.656 6.656 0 0 0 38.648 32 6.656 6.656 0 0 0 32 25.352"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#153626",
    d: "M32.146 49.417c-.161 0-.291.13-.291.291Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loopLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};
export default SvgLoopLogo;